// extracted by mini-css-extract-plugin
export var addressFields = "_pv-0";
export var animationContainer = "_pv-1";
export var footer = "_pv-2";
export var lineItems = "_pv-3";
export var modalContent = "_pv-4";
export var orderName = "_pv-5";
export var strong = "_pv-6";
export var warning = "_pv-7";